export const da = {
    Shirt: 'Trøje',
    Shirts: 'Trøjer',
    Short: 'Shorts',
    Shorts: 'Shorts',
    Sock: 'Strømper',
    Socks: 'Strømper',
    'Player Colours': 'Spillerfarver',
    'Goalkeeper Colours': 'Målmandsfarver',
    LongSleeves: 'Langærmet (L/Æ)',
    NeedHelp: 'Hjælp? ',
    Total: 'Total',
    TotalDiscount: 'Samlet rabat',
    EstimatedDeliveryTime: 'Forventet leveringstid',
    VATtext: 'Alle priser er inkl. moms',
    SelectedKit: 'Valgt sæt',
    Pick_Color: 'Vælg farve',
    Pick_quantity: 'Vælg antal',
    Print_Options: 'Trykmuligheder',
    Review_Order: 'Gennemse ordren',
    Size: 'Størrelse',
    Days: 'Hverdage',
    PlayerName: 'Spillernavn',
    PlayerNumber: 'Spillernummer ',
    SponsorLogo: 'Sponsor logo',
    ClubLogo: 'Klub logo',
    Explore: 'Udforsk',
    UnisportLogo: 'Unisport Logo',
    Preview: 'Placering af logo',
};

export const nb = {
    Shirt: 'Drakt',
    Shirts: 'Drakter',
    Short: 'Shorts',
    Shorts: 'Shorts',
    Sock: 'Strømper',
    Socks: 'Strømper',
    'Player Colours': 'Farger utespillere',
    'Goalkeeper Colours': 'Farger keeper',
    LongSleeves: 'Langermet',
    NeedHelp: 'Trenger du hjelp?',
    Total: 'Totalt',
    TotalDiscount: 'Total rabatt',
    EstimatedDeliveryTime: 'Forventet leveringstid',
    VATtext: 'Alle prisene er inkl. moms og toll',
    SelectedKit: 'Valgt sett',
    Pick_Color: 'Velg farge',
    Pick_quantity: 'Velg antall',
    Print_Options: 'Trykk',
    Review_Order: 'Ordreoversikt',
    Size: 'Størrelse',
    Days: 'Dager',
    PlayerName: 'Spillernavn',
    PlayerNumber: 'Spillernummer',
    SponsorLogo: 'Sponsorlogo',
    ClubLogo: 'Klubblogo',
    Explore: 'Utforsk',
    UnisportLogo: 'Unisport Logo',
    Preview: 'Plassering av logo',
};

export const fi = {
    Shirt: 'Paita',
    Shirts: 'Paidat',
    Short: 'Shortsit',
    Shorts: 'Shortsit',
    Sock: 'Sukka',
    Socks: 'Sukat',
    'Player Colours': 'Pelaajien värit',
    'Goalkeeper Colours': 'Maalivahdin värit',
    LongSleeves: 'Pitkät hihat',
    NeedHelp: 'Tarvisetko apua?',
    Total: 'Yhteensä',
    TotalDiscount: 'Alennus yhteensä',
    EstimatedDeliveryTime: 'Arvioitu toimitusaika',
    VATtext: 'Kaikki hinnat sis. alv.',
    SelectedKit: 'Valittu peliasu',
    Pick_Color: 'Valitse väri',
    Pick_quantity: 'Valitse määrä',
    Print_Options: 'Painatukset',
    Review_Order: 'Tilauksen yhteenveto',
    Size: 'Størrelse',
    Days: 'työpäivää',
    PlayerName: 'Pelaajan nimi',
    PlayerNumber: 'Pelaajan numero',
    SponsorLogo: 'Sponsorilogo',
    ClubLogo: 'Seura',
    Explore: 'Tutustu',
    UnisportLogo: 'Unisport Logo',
    Preview: 'Logon esikatselu',
};

export const sv = {
    Shirt: 'Tröja',
    Shirts: 'Tröjor',
    Short: 'Shorts',
    Shorts: 'Shorts',
    Sock: 'Strumpor',
    Socks: 'Strumpor',
    'Player Colours': 'Färger utespelare',
    'Goalkeeper Colours': 'Färger målvakt',
    LongSleeves: 'Långärmat',
    NeedHelp: 'Hjälp',
    Total: 'Total',
    TotalDiscount: 'Sammanlagd rabatt',
    EstimatedDeliveryTime: 'Förväntad leveranstid',
    VATtext: 'Alla priser visas inkl. moms',
    SelectedKit: 'Valt matchställ',
    Pick_Color: 'Välj färg',
    Pick_quantity: 'Välj antal',
    Print_Options: 'Välj tryck',
    Review_Order: 'Sammanfattning',
    Size: 'Storlek',
    Days: 'dagar',
    PlayerName: 'Spelarnamn',
    PlayerNumber: 'Spelarnummer',
    SponsorLogo: 'Sponsor-logo',
    ClubLogo: 'Klubb-logo',
    Explore: 'Utforska',
    UnisportLogo: 'Unisport Logo',
    Preview: 'Placering av logo',
};

export const at = {
    Shirt: 'Trikot',
    Shirts: 'Trikots',
    Short: 'Shorts',
    Shorts: 'Shorts',
    Sock: 'Stutzen',
    Socks: 'Stutzen',
    'Player Colours': 'Spielerfarben',
    'Goalkeeper Colours': 'Torwartfarben',
    LongSleeves: 'Langärmlig',
    NeedHelp: 'Brauchst du Hilfe?',
    Total: 'Total',
    TotalDiscount: 'Rabatt Total',
    EstimatedDeliveryTime: 'Voraussichtliche Lieferzeit',
    VATtext: 'Alle Preise inkl. MwSt.',
    SelectedKit: 'Ausgewähltes Set',
    Pick_Color: 'Farbe wählen',
    Pick_quantity: 'Anzahl wählen',
    Print_Options: 'Druckmöglichkeiten',
    Review_Order: 'Bestellübersicht',
    Size: 'Größe',
    Days: 'Werktage',
    PlayerName: 'Spielername',
    PlayerNumber: 'Spielernummer',
    SponsorLogo: 'Sponsorlogo',
    ClubLogo: 'Vereinslogo',
    Explore: 'Entdecken',
    UnisportLogo: 'Unisport Logo',
    Preview: 'Platzierung des Logos',
};

export const de = {
    Shirt: 'Trikot',
    Shirts: 'Trikots',
    Short: 'Shorts',
    Shorts: 'Shorts',
    Sock: 'Stutzen',
    Socks: 'Stutzen',
    'Player Colours': 'Spielerfarben',
    'Goalkeeper Colours': 'Torwartfarben',
    LongSleeves: 'Langärmlig',
    NeedHelp: 'Brauchst du Hilfe?',
    Total: 'Total',
    TotalDiscount: 'Rabatt Total',
    EstimatedDeliveryTime: 'Voraussichtliche Lieferzeit',
    VATtext: 'Alle Preise inkl. MwSt.',
    SelectedKit: 'Ausgewähltes Set',
    Pick_Color: 'Farbe wählen',
    Pick_quantity: 'Anzahl wählen',
    Print_Options: 'Druckmöglichkeiten',
    Review_Order: 'Bestellübersicht',
    Size: 'Größe',
    Days: 'Werktage',
    PlayerName: 'Spielername',
    PlayerNumber: 'Spielernummer',
    SponsorLogo: 'Sponsorlogo',
    ClubLogo: 'Vereinslogo',
    Explore: 'Entdecken',
    UnisportLogo: 'Unisport Logo',
    Preview: 'Platzierung des Logos',
};

export const fr = {
    Shirt: 'Maillot',
    Shirts: 'Maillots',
    Short: 'Short',
    Shorts: 'Shorts',
    Sock: 'Chaussette',
    Socks: 'Chaussettes',
    'Player Colours': 'Couleur du joueur',
    'Goalkeeper Colours': 'Couleur du gardien',
    LongSleeves: 'Manches longues (ou courtes?)',
    NeedHelp: "Besoin d'aide?",
    Total: 'Total',
    TotalDiscount: 'Réduction totale',
    EstimatedDeliveryTime: 'Temps de livraison estimé',
    VATtext: 'Tous les prix inclus la TVA',
    SelectedKit: 'Kit sélectionné',
    Pick_Color: 'Choisir une couleur',
    Pick_quantity: 'Choisir la quantité',
    Print_Options: "Options d'impression",
    Review_Order: 'Vérifier la commande',
    Size: 'Taille',
    Days: 'Jours',
    PlayerName: 'Nom du joueur',
    PlayerNumber: 'Numéro du joueur',
    SponsorLogo: 'Logo du sponsor',
    ClubLogo: 'Logo du club',
    Explore: 'Découvrir',
    UnisportLogo: 'Unisport Logo',
    Preview: 'Emplacement du logo',
};

export const nl = {
    Shirt: 'Shirt',
    Shirts: 'Shirts',
    Short: 'Shorts',
    Shorts: 'Shorts',
    Sock: 'Kous',
    Socks: 'Kousen',
    'Player Colours': 'Spelerskleuren',
    'Goalkeeper Colours': 'Keeperskleuren',
    LongSleeves: 'Lange mouwen',
    NeedHelp: 'Hulp nodig?',
    Total: 'Totaal',
    TotalDiscount: 'Totale korting',
    EstimatedDeliveryTime: 'Verwachte bezorgtijd',
    VATtext: 'Alle prijzen zijn inclusief BTW.',
    SelectedKit: 'Geselecteerde tenue',
    Pick_Color: 'Kies een kleur',
    Pick_quantity: 'Kies een hoeveelheid',
    Print_Options: 'Bedrukking',
    Review_Order: 'Controleer je bestelling',
    Size: 'Maat',
    Days: 'Werkdagen',
    PlayerName: 'Spelersnaam',
    PlayerNumber: 'Rugnummer',
    SponsorLogo: 'Sponsorlogo',
    ClubLogo: 'Clublogo',
    Explore: 'Ontdek',
    UnisportLogo: 'Unisport Logo',
    Preview: 'Plaatsing van het logo',
};

export const en = {
    Shirt: 'Shirt',
    Shirts: 'Shirts',
    Short: 'Short',
    Shorts: 'Shorts',
    Sock: 'Sock',
    Socks: 'Socks',
    'Player Colours': 'Player Colours',
    'Goalkeeper Colours': 'Goalkeeper Colours',
    LongSleeves: 'Long sleeves',
    NeedHelp: 'Need help?',
    Total: 'Total',
    TotalDiscount: 'Total discount',
    EstimatedDeliveryTime: 'Estimated delivery time',
    VATtext: 'All prices are included VAT.',
    SelectedKit: 'Selected Kit',
    Pick_Color: 'Pick Color',
    Pick_quantity: 'Pick quantity',
    Print_Options: 'Print Options',
    Review_Order: 'Review Order ',
    Size: 'Size',
    Days: 'Days',
    PlayerName: 'Player name',
    PlayerNumber: 'Player number ',
    SponsorLogo: 'Sponsor logo',
    ClubLogo: 'Club logo',
    Explore: 'Explore',
    UnisportLogo: 'Unisport Logo',
    Preview: 'Preview',
};
